//  import React from 'react';
// import { Outlet, Navigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../../contexts/AuthContext';
// import NotFound from '../NotFound';

// const ProtectedLayout = ({ allowedRoles }) => {
//     const location = useLocation();
//     const { user, loading } = useAuth();

//     if (loading) return <div>Loading...</div>;

//     if (!user) {
//         return <Navigate to="/" state={{ from: location }} replace />;
//     }
//      // Check if user has any of the allowed roles
//      if (allowedRoles && !allowedRoles.includes(user?.role_id?.role_name)) {
//         return <NotFound />;
//     }

//     return <Outlet />;
// };

// export default ProtectedLayout;



import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import NotFound from '../NotFound';

const ProtectedLayout = ({ allowedRoles }) => {
    const location = useLocation();
    const { user, loading } = useAuth();

    // ✅ detect maintenance route
    const isMaintenance = location.pathname === "/maintenance";

    // if (loading) return <div>Loading...</div>;

    // ✅ FIX: don't redirect if maintenance page
    if (!user && !isMaintenance) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // ✅ role check (skip in maintenance)
    if (!isMaintenance && allowedRoles && !allowedRoles.includes(user?.role_id?.role_name)) {
        return <NotFound />;
    }

    return <Outlet />;
};

export default ProtectedLayout;